import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { cx } from 'utils/cx'
import styles from './ChatDialogCloseConfirm.module.scss'

import { ButtonPrimary } from '@fukku/button/Primary'
import { ButtonSecondary } from '@fukku/button/Secondary'
import text from 'fukku/styles/texts.module.scss'

import fukkuClasses from 'fukku/styles/classes.module.scss'
import { useEffect, useRef } from 'react'

interface ChatDialogCloseConfirmProps {
	readonly onCancelLeave: () => void
	readonly onLeave: () => void
}

export function ChatDialogCloseConfirm({
	onCancelLeave,
	onLeave,
}: ChatDialogCloseConfirmProps) {
	const { t } = useLabels()

	const exitTitleRef = useRef<HTMLParagraphElement>(null)

	useEffect(() => {
		exitTitleRef.current?.focus()
	}, [])

	return (
		<>
			<button className={styles.overlay} onClick={onCancelLeave} type='button'>
				<p className={fukkuClasses.srOnly}>
					{t('assistant.close.cancel.button')}
				</p>
			</button>
			<div className={cx(styles.chatDialogCloseConfirm)}>
				<p
					className={cx(styles.exitTitle, text.uppercaseM)}
					tabIndex={-1}
					ref={exitTitleRef}
				>
					{t('assistant.close.title')}
				</p>
				<p className={styles.exitSubtitle}>{t('assistant.close.bodycopy')}</p>
				<ButtonPrimary className={styles.leaveButton} onClick={onLeave}>
					{t('assistant.close.confirm.button')}
				</ButtonPrimary>
				<ButtonSecondary onClick={onCancelLeave}>
					{t('assistant.close.cancel.button')}
				</ButtonSecondary>
			</div>
		</>
	)
}
